// @flow
import { assign } from 'lodash';
import { connect } from 'react-redux';
import { deleteGetAndStoreReports, shareReport } from '../modules/actions';
import Reports from '../components/pages/Reports';

function mapStateToProps(state: State) {
    return {
        reportsExist: state.reports.length > 0,
        user: state.user
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        onDeleteReport: (reportId, clientId) => {
            ownProps.history.replace(assign({}, ownProps.location, { pathname: '/reports' }));
            dispatch(deleteGetAndStoreReports(reportId, clientId)).catch(err => console.error(err));
            return Promise.resolve();
        },
        onShareReport: (reportId, messageDetails) => {
            dispatch(shareReport(reportId, messageDetails)).catch(err =>
                console.error(err)
            );
            return Promise.resolve();
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Reports);



// WEBPACK FOOTER //
// ./containers/ReportContainer.jsx